import { ethers, formatEther, formatUnits, parseEther } from "ethers";
import { generateKey } from "openpgp";
import {
  customJsonStringify,
  initProfileTokens,
  isValidSolanaBase58PrivateKey,
  postToEndpoint,

} from "../utils/utils"
import {
  apiv4_endpoint,
  conetDepinProvider,
  conetProvider,
  localDatabaseName,
  rewardWalletAddress,
  payment_endpoint,
  paypal_endpoint,
  changeRPC,
  ethProvider,
  sGB_ReadOnly,
  sGB_AirdropReadonly

} from "../utils/constants"

import {getBalanceFromPDA, initDuplicate} from './subscription'

import contracts from "../utils/contracts";
import { CoNET_Data, setCoNET_Data } from "../utils/globals";
import * as Bip39 from "bip39";
import { Connection, PublicKey } from "@solana/web3.js";
import { Keypair } from "@solana/web3.js";
import Bs58 from "bs58";
import { scanSolanaSol, scanSolanaSp, scanSolanaUsdt } from "./listeners";
import axios from 'axios';
import { blast_CNTPAbi } from "./../utils/abis";

const SPOracleSmartContract = new ethers.Contract(contracts.SpOracle.address, contracts.SpOracle.abi, conetDepinProvider)
const PouchDB = require("pouchdb").default;

export const initSolana = async (mnemonic: string): Promise<{publicKey: string, privateKey: string}|null> => {
  if (!Bip39.validateMnemonic(mnemonic)) return null;

  const seed = (await Bip39.mnemonicToSeed(mnemonic)).slice(0, 32);
  const keypair = Keypair.fromSeed(new Uint8Array(seed));

  return {
    publicKey: keypair.publicKey.toBase58(),
    privateKey: Bs58.encode(keypair.secretKey),
  };
}

const isValidSolanaPublicKey = (publicKey: string) => {
  try{
    const walletPubKey = new PublicKey(publicKey);
  } catch(ex) {
    return false
  }
  return true
}

const createOrGetWallet = async (secretPhrase: string | null, initAccount = false, referrals = '', ChannelPartners = '' ) => {
  await checkStorage();

  if (secretPhrase|| initAccount ) setCoNET_Data(null);

  if (!CoNET_Data || !CoNET_Data?.profiles) {
    const acc = createKeyHDWallets(secretPhrase);

    const key = await createGPGKey("", "", "");

    if (!acc) return;

    const profile: profile = {
		tokens: initProfileTokens(),
		publicKeyArmor: acc.publicKey,
		keyID: acc.address,
		isPrimary: true,
		referrer: null,
		isNode: false,
		pgpKey: {
			privateKeyArmor: key.privateKey,
			publicKeyArmor: key.publicKey,
		},
		privateKeyArmor: acc.signingKey.privateKey,
		hdPath: acc.path,
		index: acc.index,
		type: "ethereum",
		webFilter: true
    };

    const data: any = {
    mnemonicPhrase: acc?.mnemonic?.phrase,
    profiles: [profile],
    isReady: true,
    ver: 0,
    nonce: 0,
    };

    if (acc?.mnemonic?.phrase) {
		const result = await initSolana(acc?.mnemonic?.phrase);
		const profile2: profile = {
			tokens: initProfileTokens(),
			publicKeyArmor: "",
			keyID: result?.publicKey || "",
			isPrimary: true,
			referrer: null,
			isNode: false,
			pgpKey: {
				privateKeyArmor: key.privateKey,
				publicKeyArmor: key.publicKey,
			},
			privateKeyArmor: result?.privateKey || "",
			hdPath: null,
			index: 0,
			type: "solana"
		}

		data.profiles.push(profile2);
    }
	
    setCoNET_Data(data)
  }



	let tmpData = CoNET_Data
	if (!tmpData) {
		return
	}



  	tmpData.ChannelPartners = ChannelPartners
	tmpData.referrals = referrals

  const result = await initSolana(tmpData?.mnemonicPhrase);
  if (
		tmpData &&
		(tmpData?.profiles.length < 2 || 
		tmpData?.profiles[1]?.type !== "solana" ||!isValidSolanaPublicKey(tmpData?.profiles[1]?.keyID) ||
		!isValidSolanaBase58PrivateKey(tmpData?.profiles[1]?.privateKeyArmor) || (result && result.publicKey !== tmpData.profiles[1].keyID))
  ) {

    const key = await createGPGKey("", "", "");

    const profile2: profile = {
		tokens: initProfileTokens(),
		publicKeyArmor: "",
		keyID: result?.publicKey || "",
		isPrimary: true,
		referrer: null,
		isNode: false,
		pgpKey: {
			privateKeyArmor: key.privateKey,
			publicKeyArmor: key.publicKey,
		},
		privateKeyArmor: result?.privateKey || "",
		hdPath: null,
		index: 0,
		type: "solana"
    };

    tmpData.profiles[1] = profile2
  }


  tmpData = await initDuplicate(tmpData)
  
  await setCoNET_Data(tmpData)

  await storeSystemData()

  if (tmpData === null) {
	return setTimeout(() => {
		return window.location.reload()
	}, 5000)
	
  }
  
  const profiles = tmpData.profiles

  return profiles
}

const createKeyHDWallets = (secretPhrase: string | null) => {
  try {
    if (!secretPhrase) return ethers.Wallet.createRandom();

    return ethers.Wallet.fromPhrase(secretPhrase);
  } catch (ex) {
    return null;
  }
};

const createGPGKey = async (passwd: string, name: string, email: string) => {
  const userId = {
    name: name,
    email: email,
  };
  const option: any = {
    type: "ecc",
    passphrase: passwd,
    userIDs: [userId],
    curve: "curve25519",
    format: "armored",
  };

  return await generateKey(option);
};

const getCONET_api_health = async () => {
  const url = `${apiv4_endpoint}health`;
  const result: any = await postToEndpoint(url, false, null);
  if (result === true || result?.health === true) {
    return true;
  }
  return false;
};

const getFaucet: (profile: profile) => Promise<boolean | any> = async (
  profile
) =>
  new Promise(async (resolve) => {
    const conet = profile?.tokens?.conet;

    const health = await getCONET_api_health();
    if (!health) {
      return resolve(false);
    }

    const url = `${apiv4_endpoint}conet-faucet`;
    let result;
    try {
      result = await postToEndpoint(url, true, { walletAddr: profile.keyID });
    } catch (ex) {
      console.log(`getFaucet postToEndpoint [${url}] error! `, ex);
      return resolve(false);
    }
    setTimeout(() => {
      return resolve(true);
    }, 1000);
  });

export const storeSystemData = async () => {
  if (!CoNET_Data) {
    return;
  }

  try {
    await storageHashData(
      "init",
      Buffer.from(customJsonStringify(CoNET_Data)).toString("base64")
    );
  } catch (ex) {
    console.log(`storeSystemData storageHashData Error!`, ex);
  }
}


const storageHashData = async (docId: string, data: string) => {
  const database = PouchDB(localDatabaseName, { auto_compaction: true });

  let doc: any;
  try {
    doc = await database.get(docId, { latest: true });

    try {
      await database.put({ _id: docId, title: data, _rev: doc._rev });
    } catch (ex) {
      console.log(`put doc storageHashData Error!`, ex);
    }
  } catch (ex: any) {
    if (/^not_found/.test(ex.name)) {
      try {
        await database.post({ _id: docId, title: data });
      } catch (ex) {
        console.log(`create new doc storageHashData Error!`, ex);
      }
    } else {
      console.log(`get doc storageHashData Error!`, ex);
    }
  }
}

const checkStorage = async () => {
  const database = PouchDB(localDatabaseName, { auto_compaction: true });

  try {
    const doc = await database.get("init", { latest: true });
    const data = JSON.parse(Buffer.from(doc.title, "base64").toString());
    setCoNET_Data(data);
  } catch (ex) {
    return console.log(
      `checkStorage have no CoNET data in IndexDB, INIT CoNET data`
    );
  }
};

const checkLocalStorageNodes = async () => {
  const database = PouchDB(localDatabaseName, { auto_compaction: true });

  try {
    const doc = await database.get("nodes", { latest: true });
    const data = JSON.parse(Buffer.from(doc.title, "base64").toString())
    return data
  } catch (ex) {
    return null
  }
}

const storageAllNodes = async (allNodes: any[]) => {
  await storageHashData('nodes', Buffer.from(JSON.stringify(allNodes)).toString('base64'))
}

const getAllPassports = async(profile: profile) => {

  const key = profile.keyID
  const provider = conetDepinProvider;
  const contractAddress = contracts.Duplicate.address;
  const contractAbi = contracts.Duplicate.abi;

  const passportContract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  )
  try {
    const result = await passportContract.getUserInfo(key)
    return result
  } catch (ex) {
    console.log(ex)
  }

}

const getCurrentPassportInfoInChain = async () => {
  if (!CoNET_Data||!CoNET_Data?.profiles) {
    return;
  }

  let provider
  let contractAddress
  let contractAbi
  const key = CoNET_Data.profiles[0].keyID

    provider = conetDepinProvider;
    contractAddress = contracts.Duplicate.address
    contractAbi = contracts.Duplicate.abi

  const passportContract = new ethers.Contract(
    contractAddress,
    contractAbi,
    provider
  )

  try {
    const result = await passportContract.getCurrentPassport(key)
	const nftNum = parseInt(result[0].toString())
	if (nftNum) {
		return {
			nftIDs: nftNum.toString(),
			expires: result[1].toString(),
			expiresDays: result[2].toString(),
			premium: result[3]
		}
	}
    
  } catch (ex) {
    console.log(ex)
  }
  return null
}

const activeNFTUrl = `${payment_endpoint}activeNFT`

const changeActiveNFT = async (nftId: string) => {
  if (!CoNET_Data?.profiles) {
    return
  }
  const profile = CoNET_Data.profiles[0]
  const solanaWallet = CoNET_Data.profiles[1].keyID
  try {
    const message = JSON.stringify({ walletAddress: profile.keyID, solanaWallet, data: nftId})
  const wallet = new ethers.Wallet(profile.privateKeyArmor)
  const signMessage = await wallet.signMessage(message)
  const sendData = {
      message, signMessage
    }

  postToEndpoint(activeNFTUrl, true, sendData)
  
  await getPassportsInfoForProfile(CoNET_Data.profiles[0])
    return true
  } catch (ex) {
    console.log(ex);
    return false
  }
};

const estimateChangeNFTGasFee = async (chain: string, nftId: string) => {
  if (!CoNET_Data) {
    return;
  }

  let provider;
  let contractAddress;
  let contractAbi;

  if (chain === "mainnet") {
    provider = conetDepinProvider;
    contractAddress = contracts.PassportMainnet.address;
    contractAbi = contracts.PassportMainnet.abi;
  } else {
    provider = conetProvider;
    contractAddress = contracts.PassportCancun.address;
    contractAbi = contracts.PassportCancun.abi;
  }

  const wallet = new ethers.Wallet(
    CoNET_Data.profiles[0].privateKeyArmor,
    provider
  );

  const passportContract = new ethers.Contract(
    contractAddress,
    contractAbi,
    wallet
  );

  try {
    if (!passportContract.changeActiveNFT) {
      throw new Error("Function changeActiveNFT not found in contract ABI.");
    }

    const gasLimit = await passportContract.changeActiveNFT.estimateGas(nftId);

    const feeData = await provider.getFeeData();
    const gasPrice = feeData.gasPrice || ethers.ZeroAddress;

    const gasFee = Number(gasLimit) * Number(gasPrice);

    return {
      gasLimit: gasLimit.toString(),
      gasPrice: formatUnits(gasPrice, "gwei"),
      gasFee: formatEther(gasFee.toString()),
    };
  } catch (ex) {
    console.error("Gas estimation failed:", ex);
  }
};


const calculateTransferNftGas = async (toAddr: string, nftId: string) => {
  if (!CoNET_Data) {
    return;
  }

  let provider;
  let contractAddress;
  let contractAbi;

  provider = conetDepinProvider;
  contractAddress = contracts.PassportMainnet.address;
  contractAbi = contracts.PassportMainnet.abi;

  const wallet = new ethers.Wallet(
    CoNET_Data.profiles[0].privateKeyArmor,
    provider
  );

  const passportContract = new ethers.Contract(
    contractAddress,
    contractAbi,
    wallet
  );

  try {
    if (!passportContract.safeTransferFrom) {
      throw new Error("Function safeTransferFrom not found in contract ABI.");
    }

    const gasLimit = await passportContract.safeTransferFrom.estimateGas(
      wallet.address,
      toAddr,
      nftId,
      1,
      "0x"
    );

    const feeData = await provider.getFeeData();
    const gasPrice = feeData.gasPrice || ethers.ZeroAddress;

    const gasFee = Number(gasLimit) * Number(gasPrice);

    return {
      gasLimit: gasLimit.toString(),
      gasPrice: formatUnits(gasPrice, "gwei"),
      gasFee: formatEther(gasFee.toString()),
    };
  } catch (ex) {
    console.error("Gas estimation failed:", ex);
  }
};

const transferNft = async (toAddr: string, nftId: string) => {
  if (!CoNET_Data) {
    return;
  }
  let provider;
  let contractAddress;
  let contractAbi;

  provider = conetDepinProvider;
  contractAddress = contracts.PassportMainnet.address;
  contractAbi = contracts.PassportMainnet.abi;

  const wallet = new ethers.Wallet(
    CoNET_Data.profiles[0].privateKeyArmor,
    provider
  );

  const passportContract = new ethers.Contract(
    contractAddress,
    contractAbi,
    wallet
  );

  try {
    const tx = await passportContract.safeTransferFrom(
      wallet.address,
      toAddr,
      nftId,
      1,
      "0x"
    );
    return tx;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

const getVpnTimeUsed = async () => {
  if (!CoNET_Data?.profiles[0]) return;

  const profile = CoNET_Data.profiles[0];

  const wallet = new ethers.Wallet(
    CoNET_Data.profiles[0].privateKeyArmor,
    conetProvider
  );

  const freePassportContract = new ethers.Contract(
    contracts.PassportCancun.address,
    contracts.PassportCancun.abi,
    wallet
  );

  let vpnTimeUsedInMin = 0;

  try {
    vpnTimeUsedInMin = await freePassportContract.balanceOf(wallet.address, 3);
  } catch (ex) {
    console.log(`getVpnTimeUsed error!`, ex);
  }

  if (vpnTimeUsedInMin) {
    profile.vpnTimeUsedInMin = vpnTimeUsedInMin;
  }

  const temp = CoNET_Data;
  temp.profiles[0] = profile;
  setCoNET_Data(temp);
}

const getPassportsInfoForProfile = async (profile: profile): Promise<void> => {
//   const tmpCancunPassports = await getPassportsInfo(profile, "cancun");

  const tmpMainnetPassports = await getAllPassports(profile)
  const mainnetPassports: passportInfo[] = [];

   const nowTime = new Date().getTime()
  for (let i = 0; i < tmpMainnetPassports[0].length; i++) {
    const expires = new Date (parseInt(tmpMainnetPassports[1][i].toString()+'000')).getTime()
	if (expires > 0 && expires <= nowTime) {
		continue
	}

    mainnetPassports.push({
      walletAddress: profile.keyID,
      nftID: parseInt(tmpMainnetPassports[0][i]),
      expires: parseInt(tmpMainnetPassports[1][i].toString()),
      expiresDays: parseInt(tmpMainnetPassports[2][i].toString()),
      premium: tmpMainnetPassports[3][i],
      network: "CONET DePIN",
    });
  }

  let allPassports: passportInfo[] = JSON.parse(JSON.stringify(mainnetPassports))

//   if (profile?.activePassport && profile.activePassport?.expiresDays !== "7") {
// 	    allPassports = allPassports?.filter(
// 			(passport) => passport.expiresDays !== 7
// 		)
//   }

  const _activePassport = await getCurrentPassportInfoInChain();
  
	const info = _activePassport ? {
		nftID: _activePassport?.nftIDs?.toString(),
		expires: _activePassport?.expires?.toString(),
		expiresDays: _activePassport?.expiresDays?.toString(),
		premium: _activePassport?.premium,
	} : null

  allPassports = allPassports.filter((passport) => passport.nftID !== 0)

  allPassports?.sort((a, b) => {
    return a.nftID - b.nftID;
  });

  profile.silentPassPassports = allPassports;

  profile.activePassport = info||profile.activePassport

  const temp = CoNET_Data;

  if (!temp) {
    return;
  }

  temp.profiles[0] = profile

  setCoNET_Data(temp);
}


let reflaseSolanaBalancesProcess = false
const refreshSolanaBalances = async (node: nodes_info) => {
  const solanaProfile = CoNET_Data?.profiles[1];

  if (!solanaProfile||reflaseSolanaBalancesProcess) {
    return false
  }

  
  
  reflaseSolanaBalancesProcess = true
    try {
      const [sol, sp, usdt, oracle] = await Promise.all([
        scanSolanaSol(node),
        scanSolanaSp(node),
        scanSolanaUsdt(node),
        getSPOracle(),
      ]);
      const solPrice = parseFloat(formatEther(oracle[4]).toString())
      const spPrice = parseFloat(formatEther(oracle[0]).toString())/2.49
      if (sol !== null) {
        const _sol = parseFloat(sol.toString())

        const sol1 = (_sol >= 1_000_000) ? (_sol/1_000_000).toFixed(3) + 'M' : _sol.toFixed(5)
        if (solanaProfile.tokens?.sol) {
          solanaProfile.tokens.sol.balance = sol1
          solanaProfile.tokens.sol.balance1 = _sol
        } else {
          solanaProfile.tokens.sol = {
          balance:sol1,
          balance1: _sol,
          network: "Solana Mainnet",
          decimal: 18,
          contract: "",
          name: "sol",
          usd: ''
          };
        }
      }
      if ( typeof solanaProfile.tokens.sol?.balance1 === 'number') {
        const sol_usd = solanaProfile.tokens.sol.balance1 * solPrice
        solanaProfile.tokens.sol.usd = sol_usd >= 1_000_000 ? (sol_usd/1_000_000).toFixed(4) + 'M' : sol_usd.toFixed(4)
      }
      

      if (usdt !== null) {
        const _usdt = parseFloat(usdt.toString())
        const usdt1 = (_usdt >= 1_000_000) ? (_usdt/1_000_000).toFixed(2) + 'M' : _usdt.toFixed(2)
        if (solanaProfile.tokens?.usdt) {
          solanaProfile.tokens.usdt.balance = usdt1
          solanaProfile.tokens.usdt.balance1 = _usdt
        } else {
          solanaProfile.tokens.usdt = {
          balance: usdt1,
          network: "Solana Mainnet",
          decimal: 18,
          contract: "",
          name: "usdt",
          balance1: _usdt,
          usd:''
          };
        }
      }

      if ( typeof solanaProfile.tokens.usdt?.balance1 === 'number') {
        const usdt_usd = solanaProfile.tokens.usdt.balance1 *1
        solanaProfile.tokens.usdt.usd = usdt_usd  >= 1_000_000 ? (usdt_usd/1_000_000).toFixed(4) + 'M' : usdt_usd.toFixed(4)
      }




      if (sp !== null) {
        const _sp = parseFloat(sp.toString())
        const sp1 = (_sp >= 1_000_000) ? (_sp/1_000_000).toFixed(2) + 'M' : _sp.toFixed(2)
        if (solanaProfile.tokens?.sp) {
          solanaProfile.tokens.sp.balance = sp1
          solanaProfile.tokens.sp.balance1 = _sp
        } else {
          solanaProfile.tokens.sp = {
          balance: sp1,
          network: "Solana Mainnet",
          decimal: 18,
          contract: "",
          name: "sp",
          balance1: _sp,
          usd:''
          };
        }
      }

      if ( typeof solanaProfile.tokens.sp?.balance1 === 'number') {
        const sp_usd = solanaProfile.tokens.sp.balance1 / spPrice
        solanaProfile.tokens.sp.usd = sp_usd  >= 1_000_000 ? (sp_usd/1_000_000).toFixed(4) + 'M' : sp_usd.toFixed(4)
      }
      


      const temp = CoNET_Data;
      
      if (temp) {
        temp.profiles[1] = {
          ...temp.profiles[1],
          tokens: {
          ...temp.profiles[1].tokens,
          sp: solanaProfile.tokens.sp,
          sol: solanaProfile.tokens.sol,
          usdt: solanaProfile.tokens.usdt,
          },
        };
        
        setCoNET_Data(temp);
      }
  
  reflaseSolanaBalancesProcess = false

  return true;
  } catch (ex) {
  reflaseSolanaBalancesProcess = false
    return false;
  }
};

const getSpClubInfo = async (profile: profile, currentPageInvitees: number) => {
  const temp = CoNET_Data;

  if (!temp) {
    return false;
  }

  const wallet = new ethers.Wallet(profile.privateKeyArmor, conetDepinProvider);
  const contract = new ethers.Contract(
    contracts.SpClub.address,
    contracts.SpClub.abi,
    wallet
  );

  if (!profile.spClub) {
    profile.spClub = {
      memberId: "0",
      referrer: "",
      referees: [],
      totalReferees: 0,
    };
  }

  try {
    const result = await contract.membership(profile.keyID);
    profile.spClub.memberId = result;
  } catch (error) {
    console.log(error);
  }

  if (profile.spClub.memberId) {
    try {
      const referrerResult = await contract.getReferrer(profile.keyID);

      if (
        referrerResult.referrer !== "0x0000000000000000000000000000000000000000"
      )
        profile.spClub.referrer = referrerResult.referrer;
      else profile.spClub.referrer = "";
    } catch (error) {
      console.log(error);
    }

    try {
      const refereesResult = await contract.getReferees(
        profile.keyID,
        currentPageInvitees
      );
      profile.spClub.totalReferees = Number(refereesResult._total_length);
      profile.spClub.referees = [];

      if (
        refereesResult?.referees?.length > 0 &&
        refereesResult?.referees?.[0] ===
          "0x0000000000000000000000000000000000000000"
      )
        profile.spClub.totalReferees = 0;

      const validReferees = refereesResult.referees.filter(
        (referee: string) =>
          referee !== "0x0000000000000000000000000000000000000000"
      );

      // Use map to handle async operations
      const refereePromises = validReferees.map(async (referee: string) => {
        const _activePassport = await getCurrentPassportInfoInChain();

        const activePassport = {
          nftID: _activePassport?.nftIDs?.toString(),
          expires: _activePassport?.expires?.toString(),
          expiresDays: _activePassport?.expiresDays?.toString(),
          premium: _activePassport?.premium,
        };

        return {
          walletAddress: referee,
          activePassport: activePassport,
        };
      });

      // Wait for all promises to resolve
      profile.spClub.referees = await Promise.all(refereePromises);
    } catch (error) {
      console.log(error);
    }
  }

  temp.profiles[0] = profile;
  setCoNET_Data(temp);
};

const getRefereesPage = async (
  profile: profile,
  currentPageInvitees: number
) => {
  const temp = CoNET_Data;

  if (!temp) {
    return false;
  }

  const wallet = new ethers.Wallet(profile.privateKeyArmor, conetDepinProvider);
  const contract = new ethers.Contract(
    contracts.SpClub.address,
    contracts.SpClub.abi,
    wallet
  );

  if (!profile.spClub) {
    profile.spClub = {
      memberId: "0",
      referrer: "",
      referees: [],
      totalReferees: 0,
    };
  }

  try {
    const refereesResult = await contract.getReferees(
      profile.keyID,
      currentPageInvitees
    );
    profile.spClub.totalReferees = Number(refereesResult._total_length);
    profile.spClub.referees = [];

    if (
      refereesResult?.referees?.length > 0 &&
      refereesResult?.referees?.[0] ===
        "0x0000000000000000000000000000000000000000"
    )
      profile.spClub.totalReferees = 0;

    const validReferees = refereesResult.referees.filter(
      (referee: string) =>
        referee !== "0x0000000000000000000000000000000000000000"
    );

    // Use map to handle async operations
    const refereePromises = validReferees.map(async (referee: string) => {
      const _activePassport = await getCurrentPassportInfoInChain();

      const activePassport = {
        nftID: _activePassport?.nftIDs?.toString(),
        expires: _activePassport?.expires?.toString(),
        expiresDays: _activePassport?.expiresDays?.toString(),
        premium: _activePassport?.premium,
      };

      return {
        walletAddress: referee,
        activePassport: activePassport,
      };
    });

    // Wait for all promises to resolve
    profile.spClub.referees = await Promise.all(refereePromises);
  } catch (error) {
    console.log(error);
  }

  temp.profiles[0] = profile;
  setCoNET_Data(temp);
}

const getSpClubMemberId = async (profile: profile) => {
  const wallet = new ethers.Wallet(profile.privateKeyArmor, conetDepinProvider);
  const contract = new ethers.Contract(
    contracts.SpClub.address,
    contracts.SpClub.abi,
    wallet
  );

  if (!profile.spClub) {
    profile.spClub = {
      memberId: "0",
      referrer: "",
      referees: [],
      totalReferees: 0,
    };
  }

  try {
    const result = await contract.membership(profile.keyID);
    profile.spClub.memberId = result;
  } catch (error) {
    console.log(error);
  }

  const temp = CoNET_Data;

  if (!temp) {
    return "0";
  }

  temp.profiles[0] = profile;
  setCoNET_Data(temp);

  return profile.spClub.memberId;
}

async function getReceivedAmounts (
  walletAddress: string,
  node: nodes_info
) {
  try {
    const walletPubKey = new PublicKey(walletAddress);
    const senderPubKey = new PublicKey(rewardWalletAddress);

    const _connection1 = new Connection(
      `http://${node.ip_addr}/solana-rpc`,
      "confirmed"
    );

    // Step 1: Get transaction signatures
    const signatures = await _connection1.getSignaturesForAddress(walletPubKey, {
      limit: 20,
    });

    if (signatures.length === 0) {
      console.log("No transactions found.");
      return [];
    }

    // For only one transaction it works. Here's an example.
    // For multiple transactions it fails because the server doesn't support it.
    
    const transaction = await _connection1.getTransaction(
      signatures[0].signature,
      {
        commitment: "confirmed",
        maxSupportedTransactionVersion: 0, // Ensures we handle versioned transactions
      }
    );
    console.log(transaction);

  } catch (error) {
    console.error("Error fetching transaction history:", error);
    return [];
  }
};

const getSPOracle = async () => {
  try {
    const quote = await SPOracleSmartContract.getQuote()
    return quote
  } catch (ex) {
    return null
  }
}


const getGB_Airdrop = async (CoNET_Data: encrypt_keys_object) => {
	const duWallet = CoNET_Data?.duplicateAccount?.keyID
	if (!duWallet) {
		return
	}
	try {
		const _airdrop  = await sGB_AirdropReadonly.getAllInfo(duWallet)
		const airdrop: IAirdrop = {
			isNewUser: _airdrop.isNewUser,
			isGenesis: _airdrop.isGenesis,
			stopTimestamp: new Date(parseInt(_airdrop.stopTimestamp.toString())*1000),
			maxGB: ethers.formatUnits(_airdrop.maxGB, 'gwei'),
			currentWeekGB: ethers.formatUnits(_airdrop.currentWeekGB, 'gwei'),
			totalUserGB: ethers.formatUnits(_airdrop.totalUserGB, 'gwei'),
			currectPassport: parseInt(_airdrop.currectPassport),
			currectThreshold: parseInt(_airdrop.currectThreshold),
			currectThresholdGB: ethers.formatUnits(_airdrop.currectThresholdGB, 'gwei'),
			totalThresholdGB: ethers.formatUnits(_airdrop.totalThresholdGB, 'gwei')

		}

		if (_airdrop.startTimestamp > 0) {
			airdrop.startTimestamp = new Date(parseInt(_airdrop.startTimestamp.toString())*1000)
		}
		console.log(airdrop)
		CoNET_Data.profiles[0].airdropEvent = airdrop

	} catch (ex) {
		return
	}
	
}

const getRewordStaus = async(node: nodes_info): Promise<boolean|null> => {
  const contract_SpReward = new ethers.Contract(contracts.SpReword.address, contracts.SpReword.abi, conetDepinProvider)

  const profiles = CoNET_Data?.profiles
  if (!profiles || profiles.length < 2 ) {
    return false
  }
  const wallet = profiles[0].keyID
  const duWallet = CoNET_Data?.duplicateAccount?.keyID
  try {
    const [ quote, status ] = await Promise.all ([
      getSPOracle(),
      contract_SpReward.isReadyReword(duWallet, profiles[1].keyID),
      refreshSolanaBalances(node)
      
    ])

    const price = formatEther(quote[2].toString())
    const initBalance = parseInt(status[1].toString())/10 ** 6
    const spReworkBalance = parseInt(price.toString())
    const SPBalance = profiles[1].tokens?.sp?.balance1
    //    balance < price && (initBalance === 0 || initBalance > 0 && initBalance > balance)
    if (SPBalance === undefined ||  SPBalance < (spReworkBalance * .95) && (initBalance === 0 || initBalance > 0 && initBalance > SPBalance)) {
      	return null
    }
	
    return status[0]
  } catch (ex) {
    return null
  }
  
}

const spRewardRequest = async (): Promise<number> => {
  if (!CoNET_Data) {
    return 0
  }
  let ret = 0
  const profile = CoNET_Data?.profiles[0]
  const solanaWallet = CoNET_Data?.profiles[1].keyID
  if (!solanaWallet||!profile) {
    return 0
  }
  
  const url = `${payment_endpoint}spReward`
  const message = JSON.stringify({ walletAddress: profile.keyID, solanaWallet})
  const wallet = new ethers.Wallet(profile.privateKeyArmor)
  const signMessage = await wallet.signMessage(message)
  const sendData = {
      message, signMessage
    }

  const result = await postToEndpoint(url, true, sendData)
  if (result === false) {
    return -1
  }

  const nft = await waitingPaymentStatus()
  if (nft === false ) {
	return -1
  }
  const nftNum = parseInt(nft)
  if (isNaN(nftNum)) {
	return -1
  }
  return nftNum

}


const scan_erc20_balance: (
  walletAddr: string,
  address: string,
  abi: any,
  provider: any
) => Promise<false | any> = (walletAddr, contractAddress, abi, provider) =>
  new Promise(async (resolve) => {
  const contract = new ethers.Contract(
    contractAddress,
    blast_CNTPAbi,
    provider
  );

  try {
    const result = await contract.balanceOf(walletAddr);
    return resolve(result);
  } catch (ex) {
    console.log(`scan_erc20_balance Error!`);
    return resolve(false);
  }
})


const scanCONETDepin = async (walletAddr: string) => {
  return await scan_erc20_balance(
    walletAddr,
    contracts.ConetDepin.address,
    contracts.ClaimableConetPoint.abi,
    conetDepinProvider
  );
  };

  const scan_natural_balance = async (walletAddr: string, provider: any) => {
  try {
    const result = await provider.getBalance(walletAddr);
    return result;
  } catch (ex) {
    changeRPC()
    console.log(`scan_natureBalance Error!`);
    return false;
  }
  };
const scanConetETH = async (walletAddr: string) => {
  return await scan_natural_balance(walletAddr, conetDepinProvider);
};
const scanETH = async (walletAddr: string) => {
  return await scan_natural_balance(walletAddr, ethProvider);
};

const ReferralsContract = new ethers.Contract(contracts.Referrals.address, contracts.Referrals.abi, conetDepinProvider)

const getReferrals = async () => {
  if (!CoNET_Data||!CoNET_Data?.duplicateAccount) {
	return null
  }
  const key = CoNET_Data?.duplicateAccount.keyID
  try {
    const ret = await
    Promise.all ([
      ReferralsContract._referees(key),
      ReferralsContract.getReferees(key, 0)
    ])
    
    return ret
  } catch (ex) {
    return null
  }
}
const SPClubPointContract = new ethers.Contract(contracts.SPClubPoint.address, contracts.SPClubPoint.abi, conetDepinProvider)
const getSPClubPoint = async (key: string) => {
  try {
    const points = await SPClubPointContract.getAllPoints(key)
    return points
  } catch (ex) {
    return null
  }
}

const get_sGB = async (duplicateAccount: string) => {
  return sGB_ReadOnly.balanceOf(duplicateAccount, 0)
}



const getProfileAssets = async (CoNETData : encrypt_keys_object) => {
  	const profile = CoNETData?.profiles[0]
  	const solanaProfile = CoNETData?.profiles[1]
	const duplicateAccount = CoNETData?.duplicateAccount?.keyID
  	const key = profile.keyID;
	if (!profile || !solanaProfile || !duplicateAccount) {
		return false;
	}

  
	if (!profile.tokens) {
		profile.tokens = initProfileTokens();
	}

	const [conetDepin, conet_eth, referrals, points, sGB] = await Promise.all([
		scanCONETDepin(key),
		scanConetETH(key),
		getReferrals(),
		getSPClubPoint(key),
		get_sGB(duplicateAccount),
		getGB_Airdrop(CoNETData)
	])

	if (profile.tokens?.sGB) {
		profile.tokens.sGB.balance =
		sGB === false
		? ""
		: parseFloat(ethers.formatUnits( sGB.toString(), 9)).toFixed(4);
	} else {
		profile.tokens.sGB = {
			balance:
			sGB === false
			? ""
			: parseFloat(ethers.formatUnits( sGB.toString(), 9)).toFixed(4),
			network: "CONET DePIN",
			decimal: 9,
			contract: contracts.sGB.address,
			name: "sGB",
		};
	}

	if (profile.tokens?.conetDepin) {
		profile.tokens.conetDepin.balance =
		conetDepin === false
		? ""
		: parseFloat(ethers.formatEther(conetDepin)).toFixed(6);
	} else {
		profile.tokens.conetDepin = {
			balance:
			conetDepin === false
			? ""
			: parseFloat(ethers.formatEther(conetDepin)).toFixed(6),
			network: "CONET DePIN",
			decimal: 18,
			contract: "",
			name: "conetDepin",
		};
	}

	if (profile.tokens?.conet_eth) {
		profile.tokens.conet_eth.balance =
		conet_eth === false
		? ""
		: parseFloat(ethers.formatEther(conet_eth)).toFixed(6);
	} else {
		profile.tokens.conet_eth = {
		balance:
		conet_eth === false
		? ""
		: parseFloat(ethers.formatEther(conet_eth)).toFixed(6),
		network: "CONET DePIN",
		decimal: 18,
		contract: "",
		name: "conet_eth",
		};
	}

	
	if (referrals) {

		if (profile.spClub && typeof profile.spClub == 'object') {
		
			if (referrals[0] !== ethers.ZeroAddress) {
				profile.referrer = profile.spClub.referrer = referrals[0]
			} else {
				profile.referrer = profile.spClub.referrer = ''
			}

			profile.spClub.totalReferees = parseInt(referrals[1][0].toString())
			profile.spClub.referees = referrals[1][1].map((n:string) => { return { walletAddress: n, activePassport: ''}})
			
		} else {

			if (referrals[0] !== ethers.ZeroAddress) {
				profile.referrer = referrals[0]
			} else {
				profile.referrer = ''
			}

			
			profile.spClub = {
				referees: referrals[1][1].map((n:string) => n),
				totalReferees: parseInt(referrals[1][0].toString()),
				memberId: '',
				referrer: profile.referrer||''
			}
		}
	}
	
	
	profile.SpClubPoints = {
		SPHolderPoint: points ? parseInt(points[0].toString()):0,
		RefferentSPHolderPoint: points ? parseInt(points[1].toString()):0,
		SubscriptionPoint: points ? parseInt(points[2].toString()):0,
		RefferentSubscriptionPoint: points ? parseInt(points[3].toString()):0,
		ClaimableSubscriptionPoint: points ? parseInt(points[4].toString()):0,
		ClaimableRefferentSubscriptionPoint: points ? parseInt(points[5].toString()):0
	}
	
	const temp = CoNET_Data;

	if (!temp) {
		return false;
	}

	temp.profiles[0] = profile;
	temp.profiles[1] = solanaProfile;
	

	setCoNET_Data(temp);
  

  return true;
}

const RealizationRedeem = async (code: string): Promise<number> => {
  if (!CoNET_Data?.profiles?.length) {
    return 0;
  }
  const profile = CoNET_Data?.profiles[0]
  const solana = CoNET_Data?.profiles[1]
  const solanaWallet = solana.keyID
  if (!solanaWallet||!profile) {
    return 0;
  }


  const url = `${payment_endpoint}codeToClient`
  const message = JSON.stringify({ walletAddress: profile.keyID, solanaWallet, uuid: code })
  const wallet = new ethers.Wallet(profile.privateKeyArmor)
  const signMessage = await wallet.signMessage(message)
  const sendData = {
      message, signMessage
    }
  try {
    const result = await postToEndpoint(url, true, sendData)
    if (typeof result === 'boolean'|| result === ''|| result?.error ) {
      return 0
    }
    const ret = await waitingPaymentStatus()
    
    if (ret === false ) {
      return 0
    }
	const retNUm = parseInt(ret)
	if (isNaN(retNUm)) {
		return 0
	}
	return retNUm
  } catch(ex) {
      console.log("EX: ", ex);
    
  }
  return 0
}


const getstripePlan = (plan: string): string => {
  switch(plan) {
    case '1': {
      return '329'
    }
    case '12': {
      return '2749'
    }
	case '3': {
		return '2860'
	}
    case '31': {
      return '3410'
    }
    default: {
      return ''
    }
  }
}

const getPaymentUrl = async (_plan: string) => {
  if (!CoNET_Data?.profiles?.length) {
    return null;
  }
  const profile = CoNET_Data?.profiles[0]
  const solanaWallet = CoNET_Data?.profiles[1].keyID
  const price = getstripePlan(_plan)

  if (!solanaWallet||!profile||!price) {
    return null
  }

  const url = `${payment_endpoint}payment_stripe`
  const message = JSON.stringify({ walletAddress: profile.keyID, solanaWallet, price})
  const wallet = new ethers.Wallet(profile.privateKeyArmor)
  const signMessage = await wallet.signMessage(message)
  const sendData = {
      message, signMessage
  }
  const result = await postToEndpoint(url, true, sendData)
  return result
}


let currentWaitingTimeout: NodeJS.Timeout

const waiting = async (url: string, waitingPaymentStatusLoop: number, sendData: any): Promise<false|number> => new Promise(async resolve => {
	const result = await postToEndpoint(url, true, sendData)
	
	if (result.status < 100|| result === false) {
		if (++waitingPaymentStatusLoop > 50 ) {
			
			return resolve(false)
		}
			
		return currentWaitingTimeout = setTimeout(() => {
			return waiting(url, waitingPaymentStatusLoop, sendData).then (jj => resolve(jj))
		}, 10 * 1000)
	
	}
	return resolve(result.status)
})


  const cleanCurrentWaitingTimeout = () => {
	clearTimeout(currentWaitingTimeout)
  }
const waitingPaymentStatus = async (): Promise<false|string> => {
	cleanCurrentWaitingTimeout()
  if (!CoNET_Data?.profiles?.length) {
    return false;
  }

  const profile = CoNET_Data?.profiles[0]
  const solanaWallet = CoNET_Data?.profiles[1]
  if (!solanaWallet||!profile) {
    return false;
  }

  const url = `${payment_endpoint}payment_stripe_waiting`
  const message = JSON.stringify({ walletAddress: profile.keyID})
  const wallet = new ethers.Wallet(profile.privateKeyArmor)
  const signMessage = await wallet.signMessage(message)
  const sendData = {
      message, signMessage
    }


  const result = await waiting (url, 0, sendData)

  return result.toString()
}

const getPaypalUrl = async (price: number) => {
  if (!CoNET_Data?.profiles?.length) {
    return null;
  }
  const profile = CoNET_Data?.profiles[0]
  const solanaWallet = CoNET_Data?.profiles[1].keyID
  if (!solanaWallet||!profile) {
    return null;
  }
  
  const url = `${paypal_endpoint}app/api/Order/createOrderNftStr?`;
  const message = JSON.stringify({ walletAddress: profile.keyID, solana: solanaWallet, price})
  const wallet = new ethers.Wallet(profile.privateKeyArmor)
  const signMessage = await wallet.signMessage(message)
  const res = await axios.post(url, {message, signMessage})
  return res.data;
}

let listening: NodeJS.Timeout|null = null
const waitingPayUrl = `${payment_endpoint}payment_stripe_waiting`

const _waitingPay = async (wallet: string) => {

  try {
    const result = await postToEndpoint(waitingPayUrl, true, { wallet })
    return result
  } catch(ex) {
    console.log("EX: ", ex)
    return false
  }
}


export {
  createOrGetWallet,
  createGPGKey,
  getCurrentPassportInfoInChain,
  changeActiveNFT,
  estimateChangeNFTGasFee,
  getFaucet,
  calculateTransferNftGas,
  transferNft,
  getVpnTimeUsed,
  getPassportsInfoForProfile,
  refreshSolanaBalances,      //      refreshSolanaBalances
  getSpClubInfo,
  getSpClubMemberId,
  getRefereesPage,
  getReceivedAmounts,
  RealizationRedeem,
  getPaymentUrl,
  waitingPaymentStatus,
  getSPOracle,
  getPaypalUrl,
  getRewordStaus,
  spRewardRequest,
  checkLocalStorageNodes,
  storageAllNodes,
  getAllPassports,
  getProfileAssets,
  cleanCurrentWaitingTimeout
}